module.exports = __webpack_public_path__ + "static/img/gaozhonglishi9.fa968dc4.jpg";